function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Splash = require('./splash');
var Faq = require('./faq');
var Workspace = require('./workspace');
var _require = require('../document'),
  hasPdf = _require.hasPdf;
var Main = /*#__PURE__*/function () {
  function Main(app, mod) {
    _classCallCheck(this, Main);
    this.app = app;
    this.mod = mod;
    this.screen = 'splash';
    this.splash = new Splash(app, mod, this);
    this.faq = new Faq(app, mod, this);
    this.workspace = new Workspace(app, mod);
  }
  return _createClass(Main, [{
    key: "render",
    value: function render() {
      if (hasPdf(this.mod.document)) {
        this.screen = 'workspace';
      }
      if (this.screen === 'faq') {
        this.faq.render();
        return;
      }
      if (this.screen === 'workspace' && hasPdf(this.mod.document)) {
        this.workspace.render();
        return;
      }
      this.screen = 'splash';
      this.splash.render();
    }
  }, {
    key: "showSplash",
    value: function showSplash() {
      this.screen = 'splash';
      this.splash.render();
    }
  }, {
    key: "showFaq",
    value: function showFaq() {
      this.screen = 'faq';
      this.faq.render();
    }
  }, {
    key: "showWorkspace",
    value: function showWorkspace() {
      this.screen = 'workspace';
      this.splash.notice = '';
      this.splash.clearStaged();
      this.workspace.show();
    }
  }, {
    key: "fail",
    value: function fail(message) {
      if (hasPdf(this.mod.document) && this.screen === 'workspace') {
        this.workspace.notice = message;
        this.workspace.render();
        return;
      }
      this.screen = 'splash';
      this.splash.notice = message;
      this.splash.render();
    }
  }]);
}();
module.exports = Main;